<template>
  <form 
    ref="form"
    data-url="/evaluator/evaluationPlan/reportTestification/annexes"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12">
        <legend>
          <p class="text-primary">Documentos anteriores</p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th>NOMBRE</th>
              <th>FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="evalTest.file_evaluation && evalTest.accreditation_applications.request_signed">
              <td class="align-middle">Solicitud de acreditación</td>
              <td class="align-middle">
                {{
                  evalTest.accreditation_applications.request_signed.user
                    .full_name
                }}
              </td>
              <td class="align-middle">
                {{
                  evalTest.accreditation_applications.request_signed.created_at
                    | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(
                      evalTest.accreditation_applications,
                      'request_signed'
                    )
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="accApp && evalTest.accreditation_applications.request_signed">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle">
                {{
                  accApp.user
                    ? `${accApp.user.first_name} ${accApp.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{ accApp.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${accApp.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>

            <tr v-if="evalTest && evalTest.file_evaluation">
              <td class="align-middle">Propuesta del equipo evaluador</td>
              <td class="align-middle">
                {{ evalTest.file_evaluation.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.file_evaluation.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'file_evaluation')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.sampling_plan_file">
              <td class="align-middle">Plan de muestreo</td>
              <td class="align-middle">
                {{ evalTest.sampling_plan_file.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.sampling_plan_file.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'sampling_plan_file')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.risk_matrix">
              <td class="align-middle">Matríz de riesgos</td>
              <td class="align-middle">
                {{ evalTest.risk_matrix.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.risk_matrix.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'risk_matrix')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest && evalTest.attendance_record508">
              <td class="align-middle">Registro de asistencia</td>
              <td class="align-middle">
                {{ evalTest.attendance_record508.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.attendance_record508.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'attendance_record508')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest && evalTest.other_record508">
              <td class="align-middle">
                <p><b>Otro: </b>{{ evalTest.other_record508_description }}</p>
              </td>
              <td class="align-middle">
                {{ evalTest.other_record508.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.other_record508.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'other_record508')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.testification_509_3">
              <td class="align-middle">
                Informe y documentación de la testificación (OEC - adicional 2)
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'testification_509_3')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="col-sm-12" v-if="evalTest && evalTest.management_system_file.length > 0">
        <legend>
          <p class="text-primary">Documentación del OEC previo la testificación</p>
        </legend>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="width: 20%">NOMBRE DEL ARCHIVO</th>
              <th scope="col">CARGADO POR</th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.management_system_file" :key="'e' + i">
              <td class="text-center">
                {{ v.filename }}
              </td>
              <td>{{v.annexed.user.full_name}}</td>
              <td class="text-center">
                {{ v.created_at | dateFormat }}
              </td>
              <td class="text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabAditional(v.annexed)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->

      <div class="col-sm-12" v-if="evalTest.testification_certification_aditional && evalTest.testification_certification_aditional.length > 0">
        <legend>
          <p class="text-primary">Documentación del OEC previo a la testificación</p>
        </legend>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="width: 20%">NOMBRE DEL ARCHIVO</th>
              <th scope="col">CARGADO POR</th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.testification_certification_aditional" :key="'e' + i">
              <td class="text-center">
                {{ v.filename }}
              </td>
              <td>{{v.annexed.user.full_name}}</td>
              <td class="text-center">
                {{ v.created_at | dateFormat }}
              </td>
              <td class="text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabAditional(v.annexed)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="col-sm-12" v-if="evalTest.testification_509_1 && evalTest.testification_509_1.length > 0">
        <legend>
          <p class="text-primary">Informes y documentación de la testificación - OEC</p>
        </legend>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="width: 20%">NOMBRE DEL ARCHIVO</th>
              <th scope="col">CARGADO POR</th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.testification_509_1" :key="'e' + i">
              <td class="text-center">
                {{ v.filename }}
              </td>
              <td>{{v.annexed.user.full_name}}</td>
              <td class="text-center">
                {{ v.created_at | dateFormat }}
              </td>
              <td class="text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabAditional(v.annexed)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="col-12">
        <legend
          v-if="
            evalTest.expert_participation_record_testification &&
            evalTest.expert_participation_record_testification.length > 0
          "
        >
          <p class="text-primary">Informe Participación Expertos Técnicos</p>
        </legend>
        <table
          class="table table-sm tamble-striped"
          v-if="
            evalTest.expert_participation_record_testification &&
            evalTest.expert_participation_record_testification.length > 0
          "
        >
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(
                item, index
              ) in evalTest.expert_participation_record_testification"
              :key="index"
            >
              <td class="align-middle">{{item.path.split("/")[item.path.split("/").length - 1]}} </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabFor(item.path)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend
          v-if="
            evalTest.testification_evaluation_questionnaire &&
            evalTest.testification_evaluation_questionnaire.length > 0
          "
        >
          <p class="text-primary">Cuestionario de testificación</p>
        </legend>
        <table
          class="table table-sm tamble-striped"
          v-if="
            evalTest.testification_evaluation_questionnaire &&
            evalTest.testification_evaluation_questionnaire.length > 0
          "
        >
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(
                item, index
              ) in evalTest.testification_evaluation_questionnaire"
              :key="index"
            >
              <td class="align-middle">{{item.path.split("/")[item.path.split("/").length - 1]}} </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabFor(item.path)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend
          v-if="
            evalTest.attendance_record_testification &&
            evalTest.attendance_record_testification.length > 0
          "
        >
          <p class="text-primary">Registro de asistencia de técnicos</p>
        </legend>
        <table
          class="table table-sm tamble-striped"
          v-if="
            evalTest.attendance_record_testification &&
            evalTest.attendance_record_testification.length > 0
          "
        >
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in evalTest.attendance_record_testification"
              :key="index"
            >
              <td class="align-middle">{{item.path.split("/")[item.path.split("/").length - 1]}} </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabFor(item.path)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->
    </div>

    <legend>
      <p class="text-primary">Anexos</p>
    </legend>

    <div class="row">
      <div class="col-md-12">
        <app-note
          class="mb-danger"
          title="Nota"
          content-type="html"
          :notes="['Todos los campos con un (*) son obligatorios']"
        />
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label
            >Registro de asistencia participación<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input type="dropzone" v-model="files_1" />
          <p class="text-center text-danger mt-2">
            <small>
              <strong>Tamaño máximo de cada archivo 8MB</strong>
            </small>
          </p>
        </div>
      </div>
      <div class="col-md-6">
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 20%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(value, key) in inputs.attendance_record_testification"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(inputs.attendance_record_testification, key)
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label
            >Cuestionario de Testificación Técnicos<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input type="dropzone" v-model="files_3" />
          <p class="text-center text-danger mt-2">
            <small>
              <strong>Tamaño máximo de cada archivo 15MB</strong>
            </small>
          </p>
        </div>
      </div>
      <div class="col-md-6">
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 20%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(
                value, key
              ) in inputs.testification_evaluation_questionnaire"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        inputs.testification_evaluation_questionnaire,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Informe Participación Expertos Técnicos </label>
          <app-input type="dropzone" v-model="files_4" />
          <p class="text-center text-danger mt-2">
            <small>
              <strong>Tamaño máximo de cada archivo 8MB</strong>
            </small>
          </p>
        </div>
      </div>
      <div class="col-md-6">
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 20%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(
                value, key
              ) in inputs.expert_participation_record_testification"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        inputs.expert_participation_record_testification,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12">
        <br />
        <div class="form-group">
          <label
            >Informe de testificación<strong class="text-danger"
              >*</strong
            ></label
          >
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="true"
            v-if="!inputs.testification_report"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'testification_report')"
              v-if="inputs.testification_report"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('testification_report')"
              v-if="inputs.testification_report"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label>Otro:</label>
          <app-input
            type="textarea"
            v-model="observations"
            placeholder="Ingrese la evidencia"
          />
          <app-input
            type="file"
            :label="inputs.file_3 ? inputs.file_3.name : $t('upload_your_file')"
            v-model="inputs.file_3"
            v-if="!inputs.other_record506"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'other_record506')"
              v-if="inputs.other_record506"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('other_record506')"
              v-if="inputs.other_record506"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <br>
        <div class="float-left mb-3 mb-3">
          <div class="form-group text-left">
            <label>¿Existen no conformidades?</label>
            <app-input
              type="radio-buttons"
              v-model="inputs.non_conformities_505"
              :list="confirm"
            />
          </div>
        </div>
      </div>
      <!-- <div class="col-md-8 mb-3" v-if="!inputs.non_conformities_505">
          <div class="form-group">
            <label>
              Informe para el cierre de hallazgos y decisión
              <b
                class="text-danger ml-2"
                style="font-size: 18px !important"
              >*</b>
            </label>
            <app-input
                type="file"
                :label="
                  inputs.file_8 ? inputs.file_8.name : $t('upload_your_file')
                "
                v-model="inputs.file_8"
                v-if="!inputs.findings_closing_report_603_first"
                :required="true"
              />
              <div>
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'findings_closing_report_603_first')"
                  v-if="inputs.findings_closing_report_603_first"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="openDeleteModal('findings_closing_report_603_first')"
                  v-if="inputs.findings_closing_report_603_first"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
          </div>
        </div> -->
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />

    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {},
      deleteModal: false,
      selected: "",
      observations: "",
      files_1: [],
      files_2: [],
      files_3: [],
      files_4: [],
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },

    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  created() {
    this.loadForm();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    getObservations() {
      let url = `/common/observations?evalTestId=${this.$store.state.evaluatorReview.evalTestId}&status=506`;
      this.axiosGet(url).then((response) => {
        var observations = response.data;
        if (observations.length > 0) {
          this.observations = observations[0].observation;
        }
      });
    },

    submit() {
      if (
        (this.files_1.length > 0 && this.validateFileSize(this.files_1) > 0) ||
        // (this.files_3.length > 0 && this.validateFileSize(this.files_3) > 0) ||
        (this.files_4.length > 0 && this.validateFileSize(this.files_4) > 0)
      ) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 20MB");
        return;
      }

      if (
        this.files_3.length > 0 &&
        this.validateFileSizeCuestionaries(this.files_3) > 0
      ) {
        this.$toastr.e(
          "El tamaño maximo permitido para Cuestionarios de Evaluación de cada archivo es de 20MB"
        );
        return;
      }
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      formData.append("other_record506_observation", this.observations);
      this.files_1.forEach((file) => {
        formData.append("files_1[]", file);
      });

      this.files_3.forEach((file) => {
        formData.append("files_3[]", file);
      });

      this.files_4.forEach((file) => {
        formData.append("files_4[]", file);
      });
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      // this.$toastr.s(res.data.message);
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
      this.files_1 = [];
      this.files_3 = [];
      this.files_4 = [];
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {},

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openTabAditional(obj) {
      const w = window.open(obj.path, "_blank");
      w.focus();
    },

    openTabFor(value) {
      const w = window.open(value, "_blank");
      w.focus();
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest.id) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTestId,
          testification_report:
            this.$store.state.evaluatorReview.evalTest.testification_report,
          evaluation_questionnaire:
            this.$store.state.evaluatorReview.evalTest.evaluation_questionnaire,
          other_record506:
            this.$store.state.evaluatorReview.evalTest.other_record506,
          report_documentary_evaluation:
            this.$store.state.evaluatorReview.evalTest
              .report_documentary_evaluation,
          evaluation_plan_report:
            this.$store.state.evaluatorReview.evalTest.evaluation_plan_report,
          attendance_record_testification:
            this.$store.state.evaluatorReview.evalTest
              .attendance_record_testification,
          testification_evaluation_questionnaire:
            this.$store.state.evaluatorReview.evalTest
              .testification_evaluation_questionnaire,
          expert_participation_record_testification:
            this.$store.state.evaluatorReview.evalTest
              .expert_participation_record_testification,
          file_evaluation:
            this.$store.state.evaluatorReview.evalTest.file_evaluation,
          attendance_record508:
            this.$store.state.evaluatorReview.evalTest.attendance_record508,
          other_record508:
            this.$store.state.evaluatorReview.evalTest.other_record508,
          non_conformities_505:
            this.$store.state.evaluatorReview.evalTest.non_conformities_505,
          findings_closing_report_603_first:
            this.$store.state.evaluatorReview.evalTest.findings_closing_report_603_first,
          other_record506_observation:
            this.$store.state.evaluatorReview.evalTest
              .observations_evaluation_team.length > 0
              ? this.$store.state.evaluatorReview.evalTest
                  .observations_evaluation_team[
                  this.$store.state.evaluatorReview.evalTest
                    .observations_evaluation_team.length - 1
                ].observation
              : "",
        };

        this.getObservations();
      }
    },

    validateFileSize(files) {
      return files.filter((file) => {
        if (file.size > 20000000) {
          return file;
        }
      }).length;
    },

    validateFileSizeCuestionaries(files) {
      return files.filter((file) => {
        if (file.size > 20000000) {
          return file;
        }
      }).length;
    },
  },
};
</script>